// @ts-nocheck
/**
 * LSG multi-line bundles + Rebuy Smart Cart.
 * Rebuy removes one line per action; this clears every cart line with the same `bundle_id`.
 *
 * 1) Intercepts remove on bundle flyout rows → bulk POST cart/update.js (primary).
 * 2) Listens for Rebuy line-item-removed events (fallback).
 * 3) Cart diff after remove click (fallback) + orphan cleanup.
 */
(function () {
  'use strict';

  /** @returns {string} */
  function cartJsUrl() {
    if (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_url) {
      return `${Theme.routes.cart_url}.js`;
    }
    var root =
      typeof Shopify !== 'undefined' && Shopify.routes && Shopify.routes.root
        ? Shopify.routes.root
        : '/';
    if (root.slice(-1) !== '/') root += '/';
    return root + 'cart.js';
  }

  /** @returns {string} */
  function cartUpdateUrl() {
    if (typeof Theme !== 'undefined' && Theme.routes && Theme.routes.cart_update_url) {
      return Theme.routes.cart_update_url;
    }
    return '/cart/update.js';
  }

  /** Strip hyphens + lowercase so UUIDs with/without dashes match. */
  function normBid(v) {
    return v == null ? '' : String(v).replace(/-/g, '').toLowerCase().trim();
  }

  /** @param {unknown} a @param {unknown} b */
  function bundleIdsEqual(a, b) {
    var na = normBid(a);
    var nb = normBid(b);
    return na !== '' && na === nb;
  }

  /** @param {Element} row */
  function getBundleIdFromFlyoutRow(row) {
    var prop = row.querySelector(
      '.rebuy-cart__flyout-item-property.property-key-bundle_id .rebuy-cart__flyout-item-property-value',
    );
    if (prop) return (prop.textContent || '').trim();

    var nameEls = row.querySelectorAll('.rebuy-cart__flyout-item-property-name');
    for (var i = 0; i < nameEls.length; i++) {
      var k = (nameEls[i].textContent || '')
        .trim()
        .replace(/\s*:\s*$/, '')
        .toLowerCase();
      if (k !== 'bundle_id') continue;
      var propEl = nameEls[i].closest('.rebuy-cart__flyout-item-property');
      var valEl =
        propEl && propEl.querySelector('.rebuy-cart__flyout-item-property-value');
      return valEl ? (valEl.textContent || '').trim() : '';
    }
    return '';
  }

  /** @param {Element} row */
  function isBundleFlyoutRow(row) {
    return normBid(getBundleIdFromFlyoutRow(row)) !== '';
  }

  var syncing = false;

  /** @type {Promise<any> | null} */
  var preRemoveCartPromise = null;

  function isRebuyRemoveControl(el) {
    if (!(el instanceof Element)) return false;
    return !!el.closest(
      '.rebuy-cart__flyout-item-remove, [data-rebuy-action="remove"], .rebuy-cart__flyout-item__remove',
    );
  }

  function snapshotCartBeforeRemove() {
    preRemoveCartPromise = fetch(cartJsUrl(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then(function (r) {
      return r.json();
    });
  }

  /**
   * Mirrors `snippets/lsg-cart-visible-quantity.liquid` / cart bubble count.
   * @param {Array<{ quantity?: number; properties?: Record<string, unknown> | null }> | undefined} items
   * @returns {number}
   */
  function lsgVisibleCartLineCountFromItems(items) {
    if (!items || !items.length) return 0;
    var count = 0;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var p = item.properties;
      var parentRaw = p && typeof p === 'object' ? p.bundle_parent : undefined;
      var isParent = parentRaw === true || parentRaw === 'true';
      if (isParent) continue;
      count += 1;
    }
    return count;
  }

  /** @param {any} cart */
  function dispatchCartBubbleFromCart(cart) {
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:updated', { bubbles: true }),
      );
    } catch (e) {}
    try {
      document.documentElement.dispatchEvent(
        new CustomEvent('shopify:cart:change', { bubbles: true }),
      );
    } catch (e2) {}
    try {
      if (!cart || !cart.items) return;
      var visible = lsgVisibleCartLineCountFromItems(cart.items);
      document.dispatchEvent(
        new CustomEvent('cart:update', {
          bubbles: true,
          detail: {
            resource: cart,
            sourceId: 'rebuy',
            data: {
              itemCount: visible,
              source: 'rebuy-line-sync',
            },
          },
        }),
      );
    } catch (e3) {}
  }

  function fetchCartAndUpdateBubble() {
    return fetch(cartJsUrl(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (r) {
        return r.json();
      })
      .then(dispatchCartBubbleFromCart)
      .catch(function () {});
  }

  /** @param {string} bidStr */
  function removeEntireBundleById(bidStr) {
    var bidNorm = normBid(bidStr);
    if (!bidNorm || syncing) return Promise.resolve();
    syncing = true;
    return fetch(cartJsUrl(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        /** @type {Record<string, number>} */
        var updates = {};
        for (var i = 0; i < cart.items.length; i++) {
          var line = cart.items[i];
          var raw = line.properties && line.properties.bundle_id;
          if (raw != null && bundleIdsEqual(raw, bidStr)) {
            updates[line.key] = 0;
          }
        }
        if (Object.keys(updates).length === 0) return null;
        return fetch(cartUpdateUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates }),
        }).then(function (r) {
          return r.json();
        });
      })
      .then(function () {
        return fetchCartAndUpdateBubble();
      })
      .catch(function () {})
      .finally(function () {
        setTimeout(function () {
          syncing = false;
        }, 400);
      });
  }

  function removeOrphanBundleComponents() {
    if (syncing) return Promise.resolve();
    syncing = true;
    return fetch(cartJsUrl(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        /** @type {Record<string, any[]>} */
        var byBid = {};
        for (var i = 0; i < cart.items.length; i++) {
          var line = cart.items[i];
          var bid = line.properties && line.properties.bundle_id;
          var bidNorm = normBid(bid);
          if (!bidNorm) continue;
          if (!byBid[bidNorm]) byBid[bidNorm] = [];
          byBid[bidNorm].push(line);
        }
        /** @type {Record<string, number>} */
        var updates = {};
        Object.keys(byBid).forEach(function (bidKey) {
          var lines = byBid[bidKey];
          var hasParent = lines.some(function (l) {
            var p = l.properties && l.properties.bundle_parent;
            return p === true || p === 'true';
          });
          if (!hasParent) {
            for (var j = 0; j < lines.length; j++) {
              updates[lines[j].key] = 0;
            }
          }
        });
        if (Object.keys(updates).length === 0) return null;
        return fetch(cartUpdateUrl(), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          credentials: 'same-origin',
          body: JSON.stringify({ updates: updates }),
        }).then(function (r) {
          return r.json();
        });
      })
      .then(function () {
        return fetchCartAndUpdateBubble();
      })
      .catch(function () {})
      .finally(function () {
        setTimeout(function () {
          syncing = false;
        }, 400);
      });
  }

  /** @param {any} detail */
  function bundleIdFromDetail(detail) {
    if (!detail || typeof detail !== 'object') return null;
    var item = detail.item || detail.line_item || detail.lineItem;
    if (!item && detail.properties) item = detail;
    if (!item) return null;
    var props = item.properties;
    if (!props || typeof props !== 'object') return null;
    var bid = props.bundle_id;
    return bid != null && bid !== '' ? String(bid) : null;
  }

  function onLineItemRemovedEvent(/** @type {CustomEvent} */ e) {
    var bid = bundleIdFromDetail(/** @type {any} */ (e).detail);
    if (bid) {
      removeEntireBundleById(bid);
      return;
    }
    setTimeout(function () {
      removeOrphanBundleComponents();
    }, 150);
  }

  var rebuyEvents = [
    'rebuy:smartcart.line-item-removed',
    'rebuy:smartcart:line-item-removed',
    'rebuy:line-item-removed',
    'rebuy.smartcart.line-item-removed',
  ];
  for (var ei = 0; ei < rebuyEvents.length; ei++) {
    document.addEventListener(rebuyEvents[ei], onLineItemRemovedEvent);
  }

  document.addEventListener(
    'pointerdown',
    function (ev) {
      if (!isRebuyRemoveControl(/** @type {Element} */ (ev.target))) return;
      snapshotCartBeforeRemove();
    },
    true,
  );

  document.addEventListener(
    'mousedown',
    function (ev) {
      if (!isRebuyRemoveControl(/** @type {Element} */ (ev.target))) return;
      snapshotCartBeforeRemove();
    },
    true,
  );

  document.addEventListener(
    'click',
    function (ev) {
      if (!(ev.target instanceof Element)) return;
      if (!isRebuyRemoveControl(ev.target)) return;

      var row = ev.target.closest('.rebuy-cart__flyout-item');
      if (row && isBundleFlyoutRow(row)) {
        var bid = getBundleIdFromFlyoutRow(row);
        if (bid) {
          ev.preventDefault();
          ev.stopImmediatePropagation();
          preRemoveCartPromise = null;
          removeEntireBundleById(bid);
          return;
        }
      }

      var snap = preRemoveCartPromise;
      preRemoveCartPromise = null;
      setTimeout(function () {
        if (!snap) {
          removeOrphanBundleComponents();
          return;
        }
        var newCartPromise = fetch(cartJsUrl(), {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
        }).then(function (r) {
          return r.json();
        });
        Promise.all([snap, newCartPromise])
          .then(function (pair) {
            var oldCart = pair[0];
            var newCart = pair[1];
            if (!oldCart || !oldCart.items || !newCart || !newCart.items) {
              removeOrphanBundleComponents();
              return;
            }
            var newKeys = {};
            for (var i = 0; i < newCart.items.length; i++) {
              newKeys[newCart.items[i].key] = true;
            }
            var removed = [];
            for (var j = 0; j < oldCart.items.length; j++) {
              if (!newKeys[oldCart.items[j].key]) removed.push(oldCart.items[j]);
            }
            if (removed.length === 1) {
              var rawBid =
                removed[0].properties && removed[0].properties.bundle_id;
              if (rawBid != null && rawBid !== '') {
                removeEntireBundleById(String(rawBid));
                return;
              }
            }
            dispatchCartBubbleFromCart(newCart);
            removeOrphanBundleComponents();
          })
          .catch(function () {
            removeOrphanBundleComponents();
          });
      }, 500);
    },
    true,
  );
})();
